import React from "react";
import BaseField from "./BaseField";

// Unit display mapping
const UNIT_LABELS = {
  none: "",
  inches: "in",
  feet: "ft",
  miles: "mi",
  millimeters: "mm",
  centimeters: "cm",
  meters: "m",
  kilometers: "km",
  liters: "L",
  gallons: "gal",
  hours: "hr",
  minutes: "min",
  seconds: "sec",
  celsius: "°C",
  fahrenheit: "°F",
  ounces: "oz",
  pounds: "lb",
  tonnes: "t",
  grams: "g",
  kilograms: "kg",
};

export default function NumberField({
  field,
  value,
  setValue,
  openViewer,
  renderInlineChildren,
  previewMode = false,
}) {
  const required = !!field.required;
  const label = field.label || "Number";
  const unit = field.config?.unit || "none";
  const unitLabel = UNIT_LABELS[unit] || "";

  return (
    <BaseField
      field={field}
      value={value}
      setValue={setValue}
      openViewer={openViewer}
      renderInlineChildren={renderInlineChildren}
      previewMode={previewMode}
    >
      {/* Label */}
      <h3 className="text-gray-800 dark:text-gray-100 text-lg font-bold mb-3 text-center">
        {label} {required && <span className="text-orange-500">*</span>}
      </h3>

      {/* Number input with unit display */}
      <div className="relative">
        <input
          type="number"
          value={value?.number?.toString?.() ?? ""}
          onChange={(e) =>
            setValue({
              ...(value || {}),
              number: e.target.value.replace(/[^0-9.-]/g, ""),
            })
          }
          placeholder="Enter number"
          className={`border-2 border-orange-500 rounded-lg p-3 bg-white dark:bg-gray-700 text-center text-base text-gray-800 dark:text-gray-100 mt-2 w-full focus:outline-none focus:ring-2 focus:ring-orange-400 ${
            unitLabel ? "pr-12" : ""
          }`}
        />
        {unitLabel && (
          <div className="absolute right-3 top-1/2 -translate-y-1/2 mt-1 text-gray-600 dark:text-gray-400 font-medium text-base pointer-events-none">
            {unitLabel}
          </div>
        )}
      </div>
    </BaseField>
  );
}
